import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _class2;
import { routeLocationAffiliateLinkPost, routeLocationAffiliatePatch, routeLocationAffiliateCouponPost, routeLocationAffiliateCouponsGet, routeLocationAffiliateTransactionsGet, routeLocationAffiliatePayoutsGet, routeLocationAffiliateInviteGet } from "@devowl-wp/api-real-commerce";
import { action, computed, flow, observable, runInAction, set } from "mobx";
import moment from "moment";
import { AffiliateCoupon } from ".";
import { RealCommerceError } from "../exceptions";
import { realCommerceRequest } from "../utils";
let Affiliate = (_class = (_class2 = class Affiliate {
  get affiliate() {
    return this.data.affiliate;
  }
  get commissions() {
    return this.data.commissions;
  }
  get invoiceAddress() {
    return this.affiliate.invoiceAddress;
  }
  get paymentDetails() {
    return this.affiliate.paymentDetails;
  }
  constructor(_data, store) {
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "busyCoupons", _descriptor2, this);
    _initializerDefineProperty(this, "busyTransactions", _descriptor3, this);
    _initializerDefineProperty(this, "busyPayouts", _descriptor4, this);
    _initializerDefineProperty(this, "coupons", _descriptor5, this);
    _initializerDefineProperty(this, "statistics", _descriptor6, this);
    _initializerDefineProperty(this, "transactions", _descriptor7, this);
    _initializerDefineProperty(this, "payouts", _descriptor8, this);
    this.transactionFilters = observable.object({
      dates: [undefined, undefined]
    }, {}, {
      deep: false
    });
    this.store = void 0;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.createLink = flow(function* (target) {
      yield this.store.probablyRenewJwt();
      try {
        const {
          link
        } = yield realCommerceRequest({
          location: routeLocationAffiliateLinkPost,
          request: {
            link: {
              target
            }
          },
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        return link;
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      }
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.fetchTransactions = flow(function* () {
      this.busyTransactions = true;
      yield this.store.probablyRenewJwt();
      try {
        const {
          dates: [from, to]
        } = this.transactionFilters;
        const {
          statistics,
          transactions
        } = yield realCommerceRequest({
          location: routeLocationAffiliateTransactionsGet,
          params: {
            from: from.toDate(),
            to: to.toDate()
          },
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        this.statistics = statistics;
        for (const row of transactions) {
          this.transactions.set(row.id, row);
        }

        // Remove stale transactions
        const activeIds = transactions.map(_ref => {
          let {
            id
          } = _ref;
          return id;
        });
        Array.from(this.transactions.keys()).forEach(potentialStaleId => {
          if (activeIds.indexOf(potentialStaleId) === -1) {
            this.transactions.delete(potentialStaleId);
          }
        });

        // Additionally, update the global header
        this.store.fetchAffiliate();
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busyTransactions = false;
      }
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.fetchPayouts = flow(function* () {
      this.busyPayouts = true;
      yield this.store.probablyRenewJwt();
      try {
        const {
          payouts
        } = yield realCommerceRequest({
          location: routeLocationAffiliatePayoutsGet,
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        for (const row of payouts) {
          this.payouts.set(row.id, row);
        }

        // Remove stale transactions
        const activeIds = payouts.map(_ref2 => {
          let {
            id
          } = _ref2;
          return id;
        });
        Array.from(this.payouts.keys()).forEach(potentialStaleId => {
          if (activeIds.indexOf(potentialStaleId) === -1) {
            this.payouts.delete(potentialStaleId);
          }
        });
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busyPayouts = false;
      }
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.fetchCoupons = flow(function* () {
      this.busyCoupons = true;
      yield this.store.probablyRenewJwt();
      try {
        const {
          coupons
        } = yield realCommerceRequest({
          location: routeLocationAffiliateCouponsGet,
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        for (const row of coupons) {
          const {
            id
          } = row;
          const existing = this.coupons.get(id);
          if (existing) {
            set(existing.data, row);
          } else {
            this.coupons.set(id, new AffiliateCoupon(row, this));
          }
        }

        // Remove stale coupons
        const activeIds = coupons.map(_ref3 => {
          let {
            id
          } = _ref3;
          return id;
        });
        Array.from(this.coupons.keys()).forEach(potentialStaleId => {
          if (activeIds.indexOf(potentialStaleId) === -1) {
            this.coupons.delete(potentialStaleId);
          }
        });
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      } finally {
        this.busyCoupons = false;
      }
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.createCoupon = flow(function* (data) {
      yield this.store.probablyRenewJwt();
      try {
        const {
          coupon
        } = yield realCommerceRequest({
          location: routeLocationAffiliateCouponPost,
          request: {
            coupon: data
          },
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        this.fetchCoupons();
        return coupon;
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      }
    });
    // eslint-disable-next-line @typescript-eslint/member-ordering
    this.updateDetails = flow(function* (data) {
      yield this.store.probablyRenewJwt();
      try {
        const {
          affiliate
        } = yield realCommerceRequest({
          location: routeLocationAffiliatePatch,
          request: {
            affiliate: data
          },
          multipart: true,
          settings: {
            headers: this.store.authorizationHeader
          }
        });
        this.data.affiliate = affiliate;
        return affiliate;
      } catch (e) {
        console.log(e);
        throw new RealCommerceError(e);
      }
    });
    this.store = store;
    this.applyTransactionDates([moment().subtract(30, "days"), moment()]);
    runInAction(() => {
      this.data = _data;
    });
  }

  /**
   * This action does not actually refetch the transaction, you need to act on your components!
   *
   * @param dates
   */
  applyTransactionDates(dates) {
    this.transactionFilters.dates = dates;
  }
}, _class2.loadInvite = flow(function* (uuid) {
  try {
    const {
      invite
    } = yield realCommerceRequest({
      location: routeLocationAffiliateInviteGet,
      params: {
        uuid
      }
    });
    return invite;
  } catch (e) {
    throw new RealCommerceError(e);
  }
}), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "busyCoupons", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "busyTransactions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "busyPayouts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "coupons", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "statistics", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "transactions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "payouts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _applyDecoratedDescriptor(_class.prototype, "affiliate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "affiliate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "commissions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "commissions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invoiceAddress", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "invoiceAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "paymentDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyTransactionDates", [action], Object.getOwnPropertyDescriptor(_class.prototype, "applyTransactionDates"), _class.prototype)), _class);
export { Affiliate };